import React, { useState } from "react";
import {
  Container,
  Wrapper,
  Title,
  Desc,
  CardContainer,
  ToggleButtonGroup,
  ToggleButton,
  Divider,
} from "./ProjectsStyle";
import ProjectCard from "../Cards/ProjectCards";
import { projects } from "../../data/constants";

const filters = [
  { id: "all", label: "All" },
  { id: "web app", label: "Web" },
  { id: "computer vision", label: "Vision" },
  { id: "data", label: "Data" },
];

const Projects = ({ setOpenModal, intro }) => {
  const [toggle, setToggle] = useState("all");
  const visible =
    toggle === "all" ? projects : projects.filter((item) => item.category === toggle);

  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
          {intro ||
            "Websites, computer-vision tools, and data apps I have published. Open a card for the code and live link."}
        </Desc>

        <ToggleButtonGroup role="tablist" aria-label="Project categories">
          {filters.map((filter, index) => (
            <React.Fragment key={filter.id}>
              {index > 0 && <Divider />}
              <ToggleButton
                $active={toggle === filter.id}
                role="tab"
                aria-selected={toggle === filter.id}
                onClick={() => setToggle(filter.id)}
              >
                {filter.label}
              </ToggleButton>
            </React.Fragment>
          ))}
        </ToggleButtonGroup>

        <CardContainer>
          {visible.map((project) => (
            <ProjectCard key={project.id} project={project} setOpenModal={setOpenModal} />
          ))}
        </CardContainer>
      </Wrapper>
    </Container>
  );
};

export default Projects;
